import { X } from '@phosphor-icons/react'
import React from 'react'

interface RecepientInputTabProps {
  text: string
  onClick?: () => void
}

const RecepientInputTab: React.FC<RecepientInputTabProps> = ({
  text,
  onClick,
}) => {
  return (
    <div
      className="px-10px radius-6 flex gap-5px align-center cursor-pointer"
      style={{ background: '#EAF6FA', height: '30px' }}
      onClick={onClick}
    >
      <p>{text}</p>
      <X size={20} color="#000" />
    </div>
  )
}

export default RecepientInputTab
